import { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Check } from 'lucide-react';

const AVATAR_OPTIONS = [
  { id: 1, url: 'https://ui-avatars.com/api/?name=A&size=200&background=FF6B6B&color=fff&bold=true&format=svg', color: 'Rouge Corail' },
  { id: 2, url: 'https://ui-avatars.com/api/?name=A&size=200&background=4ECDC4&color=fff&bold=true&format=svg', color: 'Turquoise' },
  { id: 3, url: 'https://ui-avatars.com/api/?name=A&size=200&background=45B7D1&color=fff&bold=true&format=svg', color: 'Bleu Ciel' },
  { id: 4, url: 'https://ui-avatars.com/api/?name=A&size=200&background=FFA07A&color=fff&bold=true&format=svg', color: 'Orange' },
  { id: 5, url: 'https://ui-avatars.com/api/?name=A&size=200&background=DDA0DD&color=fff&bold=true&format=svg', color: 'Mauve' },
  { id: 6, url: 'https://ui-avatars.com/api/?name=A&size=200&background=F06292&color=fff&bold=true&format=svg', color: 'Rose' },
  { id: 7, url: 'https://ui-avatars.com/api/?name=A&size=200&background=9575CD&color=fff&bold=true&format=svg', color: 'Violet' },
  { id: 8, url: 'https://ui-avatars.com/api/?name=A&size=200&background=7986CB&color=fff&bold=true&format=svg', color: 'Indigo' },
  { id: 9, url: 'https://ui-avatars.com/api/?name=A&size=200&background=66BB6A&color=fff&bold=true&format=svg', color: 'Vert' },
  { id: 10, url: 'https://ui-avatars.com/api/?name=A&size=200&background=FFA726&color=fff&bold=true&format=svg', color: 'Ambre' },
  { id: 11, url: 'https://ui-avatars.com/api/?name=A&size=200&background=26C6DA&color=fff&bold=true&format=svg', color: 'Cyan' },
  { id: 12, url: 'https://ui-avatars.com/api/?name=A&size=200&background=AB47BC&color=fff&bold=true&format=svg', color: 'Pourpre' },
];

const AvatarSelector = ({ userName, onSelect, selectedAvatar }) => {
  const [hoveredId, setHoveredId] = useState(null);

  // Générer l'URL avec les initiales de l'utilisateur
  const getAvatarUrl = (option) => {
    const initials = userName
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
    
    return option.url.replace('name=A', `name=${initials}`);
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-medium mb-2">Ou choisissez un avatar</h3>
        <p className="text-xs text-gray-500 mb-4">
          Sélectionnez une couleur pour votre avatar avec vos initiales
        </p>
      </div>

      <div className="grid grid-cols-4 sm:grid-cols-6 gap-3">
        {AVATAR_OPTIONS.map((option) => {
          const avatarUrl = getAvatarUrl(option);
          const isSelected = selectedAvatar === avatarUrl;

          return (
            <button
              key={option.id}
              onClick={() => onSelect(avatarUrl)}
              onMouseEnter={() => setHoveredId(option.id)}
              onMouseLeave={() => setHoveredId(null)}
              className={`relative rounded-lg overflow-hidden transition-all duration-200 ${
                isSelected
                  ? 'ring-4 ring-purple-500 scale-110'
                  : 'hover:scale-105 hover:shadow-lg'
              }`}
              title={option.color}
            >
              <img
                src={avatarUrl}
                alt={option.color}
                className="w-full h-full object-cover"
              />
              {isSelected && (
                <div className="absolute inset-0 bg-purple-500/20 flex items-center justify-center">
                  <div className="bg-purple-500 rounded-full p-1">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                </div>
              )}
              {hoveredId === option.id && !isSelected && (
                <div className="absolute inset-0 bg-black/10" />
              )}
            </button>
          );
        })}
      </div>

      {selectedAvatar && (
        <div className="flex items-center gap-2 p-3 bg-purple-50 rounded-lg">
          <img src={selectedAvatar} alt="Sélectionné" className="w-12 h-12 rounded-full" />
          <div className="text-sm">
            <p className="font-medium text-purple-900">Avatar sélectionné</p>
            <p className="text-xs text-purple-600">Cliquez "Enregistrer" pour appliquer</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarSelector;
